const Marquee = ({ items, className = "" }) => {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={`${key}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-mono text-xs md:text-sm uppercase tracking-[0.25em] text-smoke">
            {item}
          </span>
          <span className="h-1 w-1 bg-blue" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="brand-marquee"
      className={`overflow-hidden border-y border-line py-5 ${className}`}
    >
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};

export default Marquee;
